// src/Hooks/useReviews.ts
import { useQuery } from '@tanstack/react-query';
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
} from 'firebase/firestore';
import { db } from '../Firebase/Config';

/* ── Types ── */

export interface Review {
  id: string;
  userName: string;
  rating: number;        // 1–5
  comment: string;
  productName?: string;
  productId?: string;
  imageUrl?: string;
  userEmail?: string;
  userId?: string;
  createdAt: any;
  updatedAt?: any;
}

/* ── Query Keys ── */

export const REVIEW_KEYS = {
  all: ['reviews'] as const,
  latest: () => ['reviews', 'latest'] as const,
};

/* ── Fetcher ── */

async function fetchLatestReviews(): Promise<Review[]> {
  const q = query(
    collection(db, 'reviews'),
    orderBy('createdAt', 'desc'),
    limit(10)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  })) as Review[];
}

/* ── Hook ── */

export const useReviews = () => {
  return useQuery<Review[], Error>({
    queryKey: REVIEW_KEYS.latest(),
    queryFn: fetchLatestReviews,
    staleTime: 1000 * 60 * 5,
  });
};